import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import keycloak from './config/keycloak';

// =========================================================
// CONTEXTOS GLOBAIS
// =========================================================
import { AuthProvider, useAuth } from './context/AuthProvider';
import { LojaProvider } from './context/LojaContext'; // NOVO CONTEXTO ADICIONADO AQUI
import { MaletaProvider } from './context/MaletaContext';

// =========================================================
// PÁGINAS E COMPONENTES
// =========================================================
import Catalogo from './pages/Catalogo';
import Maleta from './components/Maleta';
import Checkout from './components/Checkout';
import CadastroCategoria from './pages/admin/CadastroCategoria';
import ListarCategorias from './pages/admin/categoria/ListarCategorias';
import AdminLayout from './pages/admin/adminLayout/AdminLayout';
import { RotaProtegida } from './components/RotaProtegida';
import './App.css';
import LeadsDashboard from './pages/admin/leads/LeadsDashboard';
import { ToastContainer } from 'react-toastify';
import TelaPDV from './pages/admin/telaPdv/telaPdv';
import ClientesDashboard from './pages/admin/cliente/ClientesDashboard';
import { GerenciarBanners } from './pages/admin/banner/GerenciarBanners';
import ListarVendas from './pages/admin/vendas/ListarVendas';
import GerenciadorWhatsapp from './pages/admin/GerenciadorWhatsapp/GerenciadorWhatsapp';
import MinhaContaLayout from './pages/admin/cliente/MinhaContaLayout';
import MeusPedidos from './pages/admin/meusPedidos/MeusPedidos';
import CadastrarRevendedor from './pages/revendedor/CadastrarRevendedor';
import DistribuirEstoque from './pages/estoque/DistribuirEstoque';

// IMPORTAÇÕES DA ÁREA DA REVENDEDORA
import RevendedorLayout from './pages/revendedor/RevendedorLayout';
import MaletaRevendedora from './pages/revendedor/MaletaRevendedora';
import FinanceiroRevendedora from './pages/revendedor/FinanceiroRevendedora';

const Loading = () => <div className="carregando">Iniciando sistema de segurança...</div>;

// DASHBOARDS
const Dashboard = () => {
  const { keycloakData } = useAuth();
  return (
    <div style={{ padding: '20px' }}>
      <h1>Visão Geral</h1>
      <p>Bem-vindo ao painel, {keycloakData?.primeiroNome || 'Usuário'}!</p>
    </div>
  );
};

const DashboardRevendedora = () => {
  const { keycloakData } = useAuth();
  return (
    <div style={{ padding: '20px' }}>
      <h1>Meu Resumo</h1>
      <p>Bem-vinda, {keycloakData?.primeiroNome || 'Revendedora'}! Aqui você acompanhará suas metas e lucros.</p>
    </div>
  );
};

function App() {
  return (
    <ReactKeycloakProvider
      authClient={keycloak}
      initOptions={{
        onLoad: 'check-sso',
        pkceMethod: 'S256',
        checkLoginIframe: false
      }}
      LoadingComponent={<Loading />}
    >
      <AuthProvider>
        <Router>
          {/* 
            A MÁGICA ACONTECE AQUI: 
            O LojaProvider fica em volta da MaletaProvider.
            Como eles estão dentro do Router, eles conseguem ler a URL.
          */}
          <LojaProvider>
            <MaletaProvider>
              <ToastContainer position="top-right" autoClose={4000} />
              
              <div className="App">
                <Maleta />
                
                <Routes>
                  {/* ========================================================= */}
                  {/* ROTAS PÚBLICAS DA LOJA */}
                  {/* ========================================================= */}
                  {/* <Route path="/" element={<main className="conteudo-principal"><Catalogo /></main>} /> */}
                  <Route path="/:slug?/checkout" element={<main className="conteudo-principal"><Checkout /></main>} />
                  
                  {/* Rota dinâmica do revendedor. Ex: /maria-silva */}
                 <Route path="/:slug?" element={<main className="conteudo-principal"><Catalogo /></main>} />

                  {/* ========================================================= */}
                  {/* ÁREA DO CLIENTE (MINHA CONTA) */}
                  {/* ========================================================= */}
                  <Route path="/:slug?/minha-conta" element={<RotaProtegida><MinhaContaLayout /></RotaProtegida>}>
                    {/* AJUSTE AQUI: Mudado de "/minha-conta/pedidos" para "pedidos" para usar caminho relativo e preservar o slug */}
                    <Route index element={<Navigate to="pedidos" replace />} />
                    <Route path="pedidos" element={<MeusPedidos />} />
                  </Route>
                  {/* ========================================================= */}
                  {/* ÁREA DA REVENDEDORA */}
                  {/* ========================================================= */}
                  <Route path="/revendedor" element={<RotaProtegida revendedoraOnly={true}><RevendedorLayout /></RotaProtegida>}>
                    <Route index element={<Navigate to="/revendedor/dashboard" replace />} />
                    <Route path="dashboard" element={<DashboardRevendedora />} />
                    <Route path="pdv" element={<TelaPDV isRevendedor={true} />} />
                    <Route path="maleta" element={<MaletaRevendedora isRevendedor={true} />} />
                    <Route path="clientes" element={<ClientesDashboard isRevendedor={true} />} />
                    <Route path="vendas" element={<ListarVendas isRevendedor={true} />} />
                    <Route path="financeiro" element={<FinanceiroRevendedora isRevendedor={true} />} />
                    <Route path="whatsapp" element={<GerenciadorWhatsapp isRevendedor={true} />} />
                  </Route>

                  {/* ========================================================= */}
                  {/* ROTAS ADMINISTRATIVAS */}
                  {/* ========================================================= */}
                  <Route path="/admin" element={<RotaProtegida adminOnly={true}><AdminLayout /></RotaProtegida>}>
                    <Route index element={<Navigate to="/admin/dashboard" replace />} />
                    <Route path="dashboard" element={<Dashboard />} />
                    <Route path="cadastrar" element={<CadastroCategoria />} />
                    <Route path="listar" element={<ListarCategorias />} />
                    <Route path="leads" element={<LeadsDashboard />} />
                    <Route path="telaPdv" element={<TelaPDV />} />
                    <Route path="telaCliente" element={<ClientesDashboard />} />
                    <Route path="vendas" element={<ListarVendas />} />
                    <Route path="config" element={<GerenciarBanners />} />
                    <Route path="config/whatsapp" element={<GerenciadorWhatsapp />} />
                    <Route path="revendedores/cadastrar" element={<CadastrarRevendedor />} />
                    <Route path="revendedores/maletas" element={<DistribuirEstoque />} />
                  </Route>
                </Routes>
              </div>
            </MaletaProvider>
          </LojaProvider>
        </Router>
      </AuthProvider>
    </ReactKeycloakProvider>
  );
}

export default App;